export const ListQueryKey = 'activityDailyConfigs';
export const DetailQueryKey = 'activityDailyConfig';
export const Urls = {
  selectUrl: '/DailyConfig/list',
  updateUrl: '/DailyConfig/update',
  deleteUrl: '/DailyConfig/delete',
  createUrl: '/DailyConfig/create',
  detailUrl: '/DailyConfig/detail'
}; // /api/subActiveConfig/list